import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg width="100%" height="980" viewBox="0 0 100% 480" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.10" fill="#8E90A2">
            <rect x="0%" y="10px" width="60%" height="40px" rx="2" />
            <rect x="0%" y="80px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="120px" width="25%" height="32px" rx="2" />
            <rect x="0%" y="180px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="210px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="240px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="270px" width="30%" height="18px" rx="2" />
            <rect x="0%" y="300px" width="60%" height="18px" rx="2" />
            <rect x="0%" y="340px" width="25%" height="32px" rx="2" />
            <rect x="0%" y="390px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="420px" width="85%" height="18px" rx="2" />
            <rect x="5%" y="460px" width="25%" height="18px" rx="2" />
            <rect x="5%" y="490px" width="22%" height="18px" rx="2" />
            <rect x="5%" y="520px" width="35%" height="18px" rx="2" />
            <rect x="5%" y="550px" width="90%" height="18px" rx="2" />
            <rect x="0%" y="590px" width="25%" height="32px" rx="2" />
            <rect x="0%" y="640px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="670px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="700px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="730px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="760px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="800px" width="25%" height="32px" rx="2" />
            <rect x="0%" y="850px" width="100%" height="18px" rx="2" />
        </g>
    </svg>
);

const WhoIsEligibleLoadingIndicator = ({ shouldAnnounce = true, ...rest }) => (
    <RootWrapper {...rest}>
        {shouldAnnounce && <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>}
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default WhoIsEligibleLoadingIndicator;
